export const USER_ROLE_OPTIONS = ['admin', 'people_experience', 'user'] as const;

export type UserRole = (typeof USER_ROLE_OPTIONS)[number];

export type User = {
  department: string;
  email: string;
  firstName: string;
  id: string;
  lastName: string;
  lastActive?: string | null;
  profileImageUrl: string;
  role: UserRole;
};

export type UsersParams = {
  search?: string;
  role?: UserRole;
  cursor?: string;
  offset?: number;
  limit?: number;
};

export type UsersResponse = {
  users: User[];
  hasMore: boolean;
  cursor: string | null;
};

export type UpdateUserRolePayload = {
  userId: string;
  role: UserRole;
};

export type ViewerMeResponse = {
  id: string;
  name: string;
  email: string | null;
  role: UserRole;
  jobTitle: string | null;
  profileImageUrl: string | null;
  department?: string | null;
  tenure?: string | null;
  timezone?: string | null;
  weeklyDigest: boolean;
  monthlyDigest: boolean;
  dismissedBanners: string[];
  managerName?: string | null;
  manager?: { id: string; name: string } | null;
};
